import { render, staticRenderFns } from "./OrderView.vue?vue&type=template&id=72906044&scoped=true&"
import script from "./OrderView.vue?vue&type=script&lang=js&"
export * from "./OrderView.vue?vue&type=script&lang=js&"
import style0 from "./OrderView.vue?vue&type=style&index=0&id=72906044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72906044",
  null
  
)

export default component.exports